export default "/_next/static/chunks/fonts/LarsseitRegular-a46e127f346de17d5b65bab74f7c3f1e.ttf";